import MapboxLayer from './MapboxLayer';
import MapboxSource from './MapboxSource';

// eslint-disable-next-line import/prefer-default-export
export const MapboxFactory = {
  typeMapping: {
    XYZ: 'raster',
    WMS: 'raster',
    GeoJSON: 'geojson',
  },

  getInstance(lConf) {
    const mapboxSource = new MapboxSource(this.typeMapping[lConf.type], lConf.source);
    const mapboxLayers = [];

    if (this.typeMapping[lConf.type] === 'raster') {
      const mapboxRasterLayer = new MapboxLayer(lConf.lid, 'raster', lConf.minZoom, lConf.maxZoom, lConf.paint, lConf.layout);
      mapboxLayers.push(mapboxRasterLayer);
    } else if (this.typeMapping[lConf.type] === 'geojson') {
      Object.keys(lConf.style).forEach((key) => {
        let mapboxGeojsonLayer;
        if (key === 'symbol') {
          mapboxGeojsonLayer = new MapboxLayer(lConf.lid, key,
            lConf.minZoom, lConf.maxZoom, lConf.style[key], lConf.symbolLayout, lConf.filter,
            lConf.extrusion, undefined, lConf.imageSource, lConf.chartOptions);
        } else {
          mapboxGeojsonLayer = new MapboxLayer(lConf.lid, key,
            lConf.minZoom, lConf.maxZoom, lConf.style[key], lConf.layout, lConf.filter, lConf.extrusion, undefined, undefined, lConf.chartOptions);
        }
        mapboxLayers.push(mapboxGeojsonLayer);
      });
      if (lConf.clusterOptions !== undefined) {
        Object.keys(lConf.clusterOptions.style).forEach((key) => {
          let mapboxGeojsonLayer;
          const { clusterOptions } = lConf;
          if (key === 'symbol') {
            mapboxGeojsonLayer = new MapboxLayer(lConf.lid, key,
              lConf.minZoom, lConf.maxZoom, clusterOptions.style[key], clusterOptions.symbolLayout, lConf.filter, lConf.extrusion, 'cluster', undefined, lConf.chartOptions);
          } else {
            mapboxGeojsonLayer = new MapboxLayer(lConf.lid, key,
              lConf.minZoom, lConf.maxZoom, clusterOptions.style[key], clusterOptions.layout, lConf.filter, lConf.extrusion, 'cluster', undefined, lConf.chartOptions);
          }
          mapboxLayers.push(mapboxGeojsonLayer);
        });
      }
    }

    const layerObject = {
      source: mapboxSource,
      layers: mapboxLayers,
      meta: {
        type: lConf.layerType,
        lid: lConf.lid,
        name: lConf.name,
        image: lConf.previewImage,
        attributionText: lConf.attributionText,
        attributionHTML: lConf.attributionHTML,
        isDefaultBaseLayer: lConf.isDefaultBaseLayer,
        displayInLayerList: lConf.displayInLayerList,
        selectable: lConf.selectable,
        floor: lConf.floor,
        showAtStart: lConf.showAtStart,
      },
    };
    return layerObject;
  },
};
